<section class="page_404">
	<div class="container">
		<div class="row">	
		<div class="col-sm-12 text-center">
			<h2>Ooooops!</h2>
			<img src="assets/images/error.jpg" alt="" />
			<h3>Sorry! Can't find the page!</h3>
			<h4>Error 404</h4>
			<p>The page you are looking for doesn'f exis’r or something wen’t wrong.</p>
			<p><a href="javascript:void(0)" (click)="indexDashboard()">Take me back To Homepage</a> to choose new directions. </p>
		</div>
		</div>
	</div>
</section>